var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconWarningYellow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.686 2.85232L2.12727 14.7773C1.57744 15.777 2.30069 17.0002 3.44159 17.0002H16.559C17.7 17.0002 18.4232 15.777 17.8734 14.7773L11.3146 2.85232C10.7448 1.81615 9.25588 1.81616 8.686 2.85232ZM10.0003 6.75016C10.4145 6.75016 10.7503 7.08595 10.7503 7.50016V11.5002C10.7503 11.9144 10.4145 12.2502 10.0003 12.2502C9.58609 12.2502 9.25031 11.9144 9.25031 11.5002V7.50016C9.25031 7.08595 9.58609 6.75016 10.0003 6.75016ZM10.7503 13.7502C10.7503 14.1644 10.4145 14.5002 10.0003 14.5002C9.58609 14.5002 9.25031 14.1644 9.25031 13.7502C9.25031 13.3359 9.58609 13.0002 10.0003 13.0002C10.4145 13.0002 10.7503 13.3359 10.7503 13.7502Z",
    fill: "#835C00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWarningYellow);
export default __webpack_public_path__ + "static/media/Icon_Warning_Yellow.9c3959eab4819bc273fcff39d831b800.svg";
export { ForwardRef as ReactComponent };